export const addPainting = async (painting, image, setStatus) => {
  const formData = new FormData()
  formData.append('data', JSON.stringify(painting))
  formData.append('file', image.data)
  const response = await fetch('api/upload', {
    method: 'POST',
    body: formData,
  })

  setStatus({ status_code: response.status })
}
